import 'css-chunksrc/client/scenes/projectListingConfiguration/form/columns/styles.scss';export default {
  "columns": "_columns_nmixb_1",
  "row": "_row_nmixb_9",
  "column": "_column_nmixb_1",
  "iconBox": "_iconBox_nmixb_37",
  "icon": "_icon_nmixb_37",
  "columnIcon": "_columnIcon_nmixb_55",
  "timeSheetIcon": "_timeSheetIcon_nmixb_64",
  "hidden": "_hidden_nmixb_69"
};